import axios from 'axios';

// Create an instance of axios
const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Set up an interceptor for the response
apiClient.interceptors.response.use(
  response => {
    // If the response was successful, there's no need to do anything
    return response;
  },
  error => {
    // If the response had an error status (like 401 Unauthorized), redirect to the login page
    if (error.response && error.response.status === 401) {
      if(window.location.pathname !== '/login') {
        window.location = '/login';
      }
    }

    // If there's an error response that's not 401, or no response at all, reject the promise with the error
    return Promise.reject(error);
  }
);

export default apiClient;